const HOURS_TO_ROUND_LOCAL_MIDNIGHT_TO_UTC_DAY = 13;

export function birthdayToLocalDate(value: Date | string): Date {
  const shifted = new Date(value);
  shifted.setUTCHours(shifted.getUTCHours() + HOURS_TO_ROUND_LOCAL_MIDNIGHT_TO_UTC_DAY);
  return new Date(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate());
}
